import { MapHelper } from './4d-helper';
import { of, Observable, Subject, from } from 'rxjs';
import { PlottableModel,Transform,TransformGroup} from './4d-objects';
import { PlottableReference } from './renderer'
declare var google: any;

/**
 * <p>Helper class for <a href="https://developers.google.com/maps/documentation/javascript/tutorial">Google Maps</a>. Contains methods to zoom to a location and add/remove a model to the map.</p>
 * <p>You can play with a(n) (<a href="https://stackblitz.com/edit/angular-demo-google">angular</a> or <a href="https://stackblitz.com/edit/react-demo-google">react</a>) demo on stackblitz.</p>
 */
export class GoogleHelper extends MapHelper {
  map
  mapRef
  constructor(map, mapRef) {
    super()
    this.map = map
    this.mapRef = mapRef
  }

  /**
   * <p>Retrieves the url for tiles.</p>
   */
  getAuthenticatedUrl(p: PlottableModel<any>, file: string, tier: number = 0): Promise<string[]> {
    return fetch(p.file('DIRECT_TOKEN_URL') + '&tier=' + tier)
      .then(r => r.json())
      .then(r => {
        if (r.status == 200 && r.payload.url && r.payload.prefix) {
          var array = r.payload.url.split('?')
          array[0] += r.payload.prefix.substring(0, r.payload.prefix.length - 2) + '/' + file
          return array
        }
        return p.file(file).split('?')
      })
  }
 
  /**
   * <p>Create a map type that gets custom tiles and overlay over the google map (<a href="https://developers.google.com/maps/documentation/javascript/maptypes#OverlayMapTypes">docs</a>).</p>
   */
  setPlottable(p: PlottableModel<any>, args?: any): Observable<PlottableReference> {
    return from(this.getAuthenticatedUrl(p, '').then(url => {
      var mapTypeID = p.id

      // Create custom map type that retrieves tiles from server
      var imageMapType = new google.maps.ImageMapType({
        getTileUrl: (coord, zoom: number) => {
          // Get NormalizedCoord
          var normalizedCoord = this.getNormalizedCoord(coord, zoom);
          if (!normalizedCoord) {
            return null;
          }
          var bound = Math.pow(2, zoom);

          return `${url[0] + zoom}/${normalizedCoord.x}/${(bound - normalizedCoord.y - 1)}.png?${url[1]}`
        },
        tileSize: { height: 256, width: 256 },
        radius: 1738000,
        isPng: true,
        maxZoom: 20,
        name: mapTypeID
      })

      // Overlay custom map
      this.map.overlayMapTypes.insertAt(0, imageMapType)
      this.map.mapTypes.set(mapTypeID, imageMapType)
      this.map.setOptions({
        mapTypeControlOptions: {
          mapTypeIds: [
            mapTypeID, 'terrain'
          ],
          style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR
        }
      })

      return { plottable: p, object: imageMapType }
    }))
  }

  clearPlottables() {
    this.map.overlayMapTypes.clear()
  }

  getMapObjectFor(p: PlottableModel<any>) {
    return this.map.mapTypes[p.id]
  }

  /**
   * <p>Get the bounds from SW and NE lat and long given [[PlottableModel]] object.</p>
   */
  getBounds(p: PlottableModel<any>) {
    return new google.maps.LatLngBounds(new google.maps.LatLng(p.llat, p.llng), new google.maps.LatLng(p.ulat, p.ulng))
  }

  /**
   * <p>Pan the camera to specified bounds.</p>
   */
  sendCameraTo(t: PlottableModel<any>, duration?: number, args?: any): Observable<any> {
    var bounds = this.getBounds(t)
    this.map.fitBounds(bounds)
    this.map.panToBounds(bounds)

    var delaySubject = new Subject()
    setTimeout(() => delaySubject.next(this.map), duration + 100)
    return delaySubject.asObservable()
  }

  /**
   * <p>Normalizes the coords that tiles repeat across the x axis (horizontally) (taken from <a href="https://developers.google.com/maps/documentation/javascript/maptypes#ImageMapTypes">GoogleMaps</a>).</p>
   */
  getNormalizedCoord(coord, zoom) {
    var y = coord.y;
    var x = coord.x;

    // tile range in one direction range is dependent on zoom level
    // 0 = 1 tile, 1 = 2 tiles, 2 = 4 tiles, 3 = 8 tiles, etc
    var tileRange = 1 << zoom;

    // don't repeat across y-axis (vertically)
    if (y < 0 || y >= tileRange) {
      return null;
    }

    // repeat across x-axis
    if (x < 0 || x >= tileRange) {
      x = (x % tileRange + tileRange) % tileRange;
    }

    return { x: x, y: y };
  }

  changeOpacity(t: Transform, opacity?: number){
    throw new Error("Not yet supported")
  }
 resolveItem(movement):PlottableModel<any>{
   throw new Error("Not yet supported")
 }
}